import React from 'react';

import { showModal } from 'modal.react.js';
import { useSelector } from 'react-redux';

import area from 'components/shared/GlobalModalArea/area';
import Modal from 'components/shared/GlobalModalArea/Modal';
import { history } from 'configureStore';
import { itinerariesItemDataSelector } from 'store/itinerariesItem/selectors';
import { accountIdSelector } from 'store/user/selectors';
import { useItinerariesItemContext } from 'utils/itineraries/context';
import { ITINERARY_STEPS } from 'utils/itineraries/itinerary/map';

import s from './index.module.css';

export function useActionButtons() {
  const proposal = useSelector(itinerariesItemDataSelector);
  const { itemType, itemId } = useItinerariesItemContext();
  const accId = useSelector(accountIdSelector);
  const isShareEnabled = proposal?.policies?.shareWithAgent || proposal?.policies?.shareWithClient;
  const isShareVisible = proposal.lastAvailableStep === ITINERARY_STEPS.LANDING;

  const handleShare = React.useCallback(() => {
    const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : window.location.origin;
    const shareUrl = `${baseUrl}/acc/${accId}/itineraries/${proposal.id}/share/new?iframe=true`;

    showModal(area, (res) => {
      const handleMessage = (event: MessageEvent<any>) => {
        if (event.data === 'closeModal') {
          res();
        }
      };
      window.addEventListener('message', handleMessage);

      const unregister = history.listen(() => {
        res();
        window.removeEventListener('message', handleMessage);
      });

      const handleClose = () => {
        res();
        unregister();
      };

      return (
        <Modal contentClassName={s.shareModal} isOpen toClose={handleClose} withoutCloseBtn>
          <iframe allow="same-origin" src={shareUrl} className={s.shareModalIframe}></iframe>
        </Modal>
      );
    });
  }, [proposal, itemId, itemType, accId]);

  return {
    isShareEnabled,
    isShareVisible,
    handleShare,
  };
}
